import { ICaseDetailsAPIResponse, IChatCaseData, IChatQueueType } from '../../interfaces/case-details-api-interfaces';

export const transformChatContextResponse = (response: ICaseDetailsAPIResponse): { caseData: IChatCaseData; queueInfo: IChatQueueType } => {
  const transformed: IChatCaseData = {} as IChatCaseData;
  Object.entries(response.data.sfProperties).forEach(([key, value]) => {
    transformed[key] = value.value;
  });
  return {
    caseData: transformed,
    queueInfo: (response.data.additionalProperties.sfConfig as IChatQueueType) || 'default',
  };
};
